import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const addShiftGroup = async (data) => {

        console.log("Shift group data",data);
        return await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-group/shift-group-create`,
            data,
        );

};

export const updateShiftGroup = async (data) => {

        console.log("Shift group data update",data);
        return await gatewayInstance.put(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-group/shift-group-update`,
            data,
        );
};

export const searchGroupData = async (data) => {
    try {
        console.log(`searchGroupData`, data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-group/shift-group-search`,
            data,
        );
        console.log(`shift serch res`, response);
        return response.data;
        return null;
    } catch (e) {
        console.error(e);
    }
};

export const getShiftGroupById = async (id) =>{
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-group/shift-group/${id}`,
        );
        console.log('shiftGroupById', response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
}
